import { _WeakSet } from '@glimmer/util';
const EMBER_ARRAYS = new _WeakSet();
export function setEmberArray(obj) {
  EMBER_ARRAYS.add(obj);
}
export function isEmberArray(obj) {
  return EMBER_ARRAYS.has(obj);
}